import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Promo icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Promo } from '@sravni/design-system-icons'
 *
 * <Promo />
 * ```
 */
var Promo = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Promo", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.443 6.293a1 1 0 1 1-1.413 1.414 1 1 0 0 1 1.413-1.414Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.393 3h3.611c.957 0 1.732.775 1.732 1.731v3.611c0 .46-.183.9-.507 1.225l-6.926 6.926a1.731 1.731 0 0 1-2.448 0l-3.612-3.611a1.731 1.731 0 0 1 0-2.449l6.926-6.926A1.732 1.732 0 0 1 12.393 3v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m5.578 9.033 6.125 6.125-6.125-6.125Z", fill: "currentColor" }))); });

export { Promo };
//# sourceMappingURL=Promo.js.map
